import { render, staticRenderFns } from "./editRekening.vue?vue&type=template&id=33d6c83e&"
import script from "./editRekening.vue?vue&type=script&lang=js&"
export * from "./editRekening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports